import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
import { computed, inject, onBeforeUnmount, onMounted, reactive, ref, watch } from "vue";
import OrderDocument from "@/model/OrderDocument";
import OrderInvoiceListRow from "@/components/admin/OrderInvoiceListRow.vue";
import { EmailServiceSymbol, OrderInvoiceServiceSymbol } from "@/InjectionSymbols";
import { EmailType } from "@/model/enum/EmailType";
import { OrderStatus } from "@/model/enum/OrderStatus";
import EmailDialog from "@/components/admin/EmailDialog.vue";
import { EditState } from "@/model/enum/EditState";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderInvoices',
    props: {
        orderId: { type: Number, required: true },
        orderStatus: { type: String, required: true },
        editState: { type: String, required: true },
        invoiced: { type: Boolean, required: true }
    },
    emits: ['orderUpdated'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const orderInvoiceService = inject(OrderInvoiceServiceSymbol);
        const emailService = inject(EmailServiceSymbol);
        let invoices = reactive([]);
        let componentUnmounted = false;
        let updatingInvoices = ref(false);
        const props = __props;
        const emit = __emit;
        __expose({
            refreshInvoices
        });
        onMounted(() => {
            if (props.orderId) {
                loadOrderInvoices();
            }
        });
        watch(() => props.orderId, () => {
            if (props.orderId) {
                loadOrderInvoices();
            }
        });
        onBeforeUnmount(() => {
            componentUnmounted = true;
        });
        const template = computed(() => {
            switch (props.orderStatus) {
                case OrderStatus.CANCELLED:
                    return EmailType.ORDER_CANCELLED;
                case OrderStatus.CONFIRMED:
                    return EmailType.ORDER_CHANGED;
                default:
                    throw new Error();
            }
        });
        function loadOrderInvoices() {
            return orderInvoiceService?.loadInvoices(props.orderId).then(response => {
                invoices.length = 0;
                for (let entry of response.data) {
                    let typedInvoice = new OrderDocument(entry.id, entry.invoiceNumber, entry.revision, entry.fileName, entry.orderId);
                    invoices.push(typedInvoice);
                }
            });
        }
        function refreshInvoices(expectedAdditionCount, expectedCount) {
            updatingInvoices.value = true;
            if (expectedCount === undefined) {
                expectedCount = invoices.length + expectedAdditionCount;
            }
            loadOrderInvoices().then(() => {
                if (componentUnmounted) {
                    return;
                }
                if (invoices.length != expectedCount) {
                    setTimeout(() => {
                        refreshInvoices(expectedAdditionCount, expectedCount);
                    }, 2000);
                }
                else {
                    updatingInvoices.value = false;
                }
            });
        }
        function openInvoice(invoice) {
            orderInvoiceService.getInvoice(invoice.fileName)
                .then(response => {
                window.open(URL.createObjectURL(response.data));
            });
        }
        function emailDocuments(emailHtmlContent, attachments) {
            emailService.sendEmail(props.orderId, template.value, emailHtmlContent, attachments);
        }
        function generateInvoice() {
            orderInvoiceService.updateInvoice(props.orderId)
                .then((response) => {
                // Emit the updated order data to the parent component
                emit('orderUpdated', response.data);
                refreshInvoices(1);
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex flex-wrap" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-6 pa-0 mb- 4" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("Rechnungen")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "v-col-6 text-end pa-0" }, {
                                default: _withCtx(() => [
                                    (__props.editState != _unref(EditState).LOCKED)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            class: "mr-2",
                                            color: "info",
                                            onClick: generateInvoice,
                                            "data-cy": "generateInvoice"
                                        }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createTextVNode("mdi-file-document-plus-outline")
                                            ])),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    _createVNode(EmailDialog, {
                                        "mail-type": template.value,
                                        "order-id": __props.orderId,
                                        attachments: _unref(invoices).map(invoice => invoice.fileName),
                                        onOnDialogConfirm: emailDocuments
                                    }, {
                                        activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_icon, _mergeProps({ color: "info" }, props), {
                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                    _createTextVNode("mdi-email-send-outline")
                                                ])),
                                                _: 2
                                            }, 1040)
                                        ]),
                                        confirmBtnText: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode("Email versenden")
                                        ])),
                                        _: 1
                                    }, 8, ["mail-type", "order-id", "attachments"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (__props.editState === _unref(EditState).EDITED && __props.invoiced)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "warning",
                            class: "mx-4",
                            density: "compact"
                        }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode(" Die Buchung wurde seit dem letzten Dokument geändert. ")
                            ])),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_table, { class: "ma-2" }, {
                        default: _withCtx(() => [
                            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Datei"),
                                    _createElementVNode("th")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                (_unref(updatingInvoices))
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_v_progress_circular, { indeterminate: true })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invoices), (invoice, index) => {
                                    return (_openBlock(), _createBlock(OrderInvoiceListRow, {
                                        class: "cursor-pointer",
                                        onClick: ($event) => (openInvoice(invoice)),
                                        key: index,
                                        invoice: invoice
                                    }, null, 8, ["onClick", "invoice"]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
